// import App from '../views/passport/App';
import Service from '../views/passport/Service';
import Home from '../views/passport/Home';
import AccountSetting from '../views/passport/AccountSetting';
import AccountUpgrade from '../views/passport/AccountUpgrade';
import Profile from '../views/passport/Profile';
import ChangePassword from '../views/passport/ChangePassword';
import SafeQuession from '../views/passport/SafeQuession';
import BindEmail from '../views/passport/BindEmail';
import FindPwd from '../views/passport/FindPwd';
import InstallService from '../views/passport/InstallService';
import AccountFollow from '../views/passport/AccountFollow';
import LoginFollow from '../views/passport/LoginFollow';
import RegistProfile from '../views/passport/RegistProfile';
import OnestoreSubscribe from '../views/passport/OnestoreSubscribe';
import OnestoreSubscribeDetail from '../views/passport/OnestoreSubscribeDetail';
import TokenLogin from '../views/passport/TokenLogin.vue';
import AccountDelete from '@views/passport/AccountDelete.vue';
export default [
  {
    path: '/',
    name: 'passport',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      index: 1
    },
    component: Home
  },
  {
    path: '/service',
    name: 'service',
    meta: {
      index: 2,
      pageUp: 1
    },
    component: Service
  },
  {
    path: '/accountSetting',
    name: 'accountSetting',
    meta: {
      index: 2
    },
    component: AccountSetting
  },
  {
    path: '/accountUpgrade',
    name: 'accountUpgrade',
    meta: {
      index: 3
    },
    component: AccountUpgrade
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      index: 3
    },
    component: Profile
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    meta: {
      index: 3
    },
    component: ChangePassword
  },
  {
    path: '/safeQuession',
    name: 'safeQuession',
    meta: {
      index: 3
    },
    component: SafeQuession
  },
  {
    path: '/bindEmail',
    name: 'bindEmail',
    meta: {
      index: 3
    },
    component: BindEmail
  },
  {
    path: '/findPwd',
    name: 'findPwd',
    meta: {
      index: 3
    },
    component: FindPwd
  },
  {
    path: '/installService',
    name: 'installService',
    component: InstallService
  },
  {
    path: '/accountFollow',
    name: 'accountFollow',
    meta: {
      index: 2
    },
    component: AccountFollow
  },
  {
    path: '/loginFollow',
    name: 'loginFollow',
    meta: {
      index: 2
    },
    component: LoginFollow
  },
  {
    path: '/registProfile',
    name: 'registProfile',
    meta: {
      index: 2
    },
    component: RegistProfile
  },
  {
    path: '/onestoreSubscribe',
    name: 'onestoreSubscribe',
    meta: {
      index: 2
    },
    component: OnestoreSubscribe
  },
  {
    path: '/onestoreSubscribe/detail',
    name: 'onestoreSubscribeDetail',
    meta: {
      index: 3
    },
    component: OnestoreSubscribeDetail
  },
  {
    path: '/tokenLogin',
    name: 'tokenLogin',
    meta: {
      index: 2
    },
    component: TokenLogin
  },
  {
    // 账号删除
    path: '/accountDelete',
    name: 'accountDelete',
    meta: {
      index: 2
    },
    component: AccountDelete
  }
];
